import React, { SyntheticEvent } from 'react';
import styles from './SearchBox.scss';
import { withDebounce } from '../../hoc/withDebounce/withDebounce';
import SearchIcon from '../../icons/dist/components/searchIcon';
import { connect } from 'react-redux';
import { theme, Theme } from '../../reducers';

interface SearchBoxProps {
  onChange(value: string): any;
  placeholder?: string;
  themeData: Theme;
}

const mapStateToProps = (state) => ({
  themeData: theme(state),
});

export const SearchBox = connect(mapStateToProps)(
  withDebounce(
    class extends React.Component<SearchBoxProps> {
      changeHandler = (e: SyntheticEvent<HTMLInputElement>) => {
        const { onChange } = this.props;
        onChange(e.currentTarget.value);
      };

      render() {
        const { placeholder, themeData } = this.props;
        const { color, backgroundColor, borderRadius } = themeData.searchBox;

        return (
          <div
            className={styles.searchBoxWrapper}
            data-hook="search-box-wrapper"
            style={{
              color,
            }}
          >
            <div
              className={styles.searchBoxBackground}
              style={{
                backgroundColor,
                borderRadius,
              }}
            >
              <SearchIcon />
              <input
                className={styles.searchBox}
                data-hook="textbox"
                type="text"
                onChange={this.changeHandler}
                placeholder={placeholder}
              />
            </div>
          </div>
        );
      }
    },
    'onChange',
  ),
);
